export const PRODUCT_INSIGHTS_RESET_STATE = 'PRODUCT_INSIGHTS_RESET_STATE';
export const PRODUCT_INSIGHTS_CURRENT_ITEM = 'PRODUCT_INSIGHTS_CURRENT_ITEM';

export const PRODUCT_INSIGHTS_REQUEST_LOADING = 'PRODUCT_INSIGHTS_REQUEST_LOADING';
export const PRODUCT_INSIGHTS_REQUEST_SUCCESS = 'PRODUCT_INSIGHTS_REQUEST_SUCCESS';
export const PRODUCT_INSIGHTS_REQUEST_FAILED = 'PRODUCT_INSIGHTS_REQUEST_FAILED';

export const PRODUCT_INSIGHTS_CURRENT_ACTION = 'PRODUCT_INSIGHTS_CURRENT_ACTION';
export const PRODUCT_INSIGHTS_RESET_ACTION = 'PRODUCT_INSIGHTS_RESET_ACTION';

export const PRODUCT_INSIGHTS_CANCEL_ACTION = 'PRODUCT_INSIGHTS_CANCEL_ACTION';
export const PRODUCT_INSIGHTS_RETURN_ACTION = 'PRODUCT_INSIGHTS_RETURN_ACTION';
